import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Message from "../../tools/Message";
import { Alert, Button, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import Spacer from "../../../components/Spacer";
import { Form, useNavigate, useParams } from 'react-router-dom';
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import Typography from '@mui/material/Typography';
import TextField from "@material-ui/core/TextField";
import MainContainer from "../../../components/MainContainer";
import { headerDataImmo } from '../../../data/modules/logistic-header';
import LoadingSimpleBackdrop from "../../tools/LoadingSimpleBackdrop";
import { FormControl, IconButton, MenuItem, Select, Collapse, AppBar, Box, Tooltip, CardHeader } from "@material-ui/core";
import VehicleService from "../../../services/VehicleService";
import MissionVehicleDetailAdd from "./MissionVehicleDetailAdd";
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { Add, Delete} from '@mui/icons-material';
import MissionTransportService from "../../../services/MissionTransportService";
import { AntTab, AntTabs } from "../../../components/ant-tab";
import TimeToLeaveIcon from '@mui/icons-material/TimeToLeave';
import CardTravelIcon from '@mui/icons-material/CardTravel';
import DirectionService from "../../../services/DirectionService";
import SendIcon from '@mui/icons-material/Send';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 2,
    borderRadius: "8px !important",
    marginTop: "1.5%",
    boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;",
    width: "100%",
  },
  tab: {
    minWidth: "400px !important",
    fontSize: "0.8rem",
  },
  AppBar: {
    borderRadius: "8px",
    boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
  },
  box: {
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    borderRadius: "8px !important",
    maxWidth: "156vh",
    minWidth: "100vh",
  },
}));

export default function MissionReplyRequestAdd() {
  const navigate = useNavigate();
  const classes = useStyles();
  const { id } = useParams();
  const missionId = id ? id : null;
  const [openRows, setOpenRows] = useState({});
  const [formValues, setFormValues] = useState({
    mission_id: missionId,
    agendas :[
    {agenda_id: 0,
    destinations: [],}
    ],
  });
  const [voituresAvalailable, setVoituresAvalailable] = useState([]);
  const [missionData, SetMissionData] = useState({});
  const [confirmationDialog, setConfirmationDialog] = React.useState({
    openDialog: false,
    messageDialog: 'Voulez vous vraiment supprimer  ?',
  });
  const { openDialog, messageDialog } = confirmationDialog;
  const [message, setMessage] = React.useState({
    open: false,
    color: 'green',
    messageInfo: '',
  });
  const { open, color, messageInfo } = message;
  const [affiche, setAffiche] = useState(false);
  const [listedestination, setListedestination] = useState([]);
  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = useState(false);
  const [drivers, setDrivers] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [vehicleCaptains, setVehicleCaptains] = useState({});
  const [vehicleDetailData, setVehicleDetailData] = useState({
    openDialog: false,
    closeDialog: false,
    missionnary: [],
  });
  const [warning, setWarning] = useState({ 
    show: false, vehicleImm: "",
    index: null,
    tIndex: null,  
  });
  const [formRequest, setFormRequest] = useState({ // pour la demande de la sollicitation voiture
    show: false,
    direction: null,
    description: "",
    missionnaries: {},
    destination: {},
    agendaId: 0,
    missionId: 0,
  });
  const [value, setValue] = useState(0);
  const [confirmationOM, setConfirmationOM] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [directions, setDirections] = useState([]);
  const [captainConfirm, setCaptainConfirm] = useState({
    open: false,
    missionnary: '',
    vehicle: '',
  });
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const formatPhoneNumber = (value) => {
    const cleaned = value.replace(/\D/g, '');
    const match = cleaned.match(/^(\d{0,3})(\d{0,2})(\d{0,3})(\d{0,2})/);
    if (!match) return '';
    return `${match[1]} ${match[2]} ${match[3]} ${match[4]}`.trim();
  };

  useEffect(() => {
    async function fetchDirections() {
      try {
        const result = await DirectionService.getDirection();
        if (result?.data) {
          setDirections(result.data);
        }
      } catch (error) {
        console.error("Error fetching directions:", error);
      }
    }

    async function fetchMissionDetails() { // recuperaion des données
      setOpenLoadingSimpleBackdrop(true);
      try {
        const result = await MissionTransportService.getDataMission(missionId); // Récupérer les informations de la mission
        if (result?.data) {
          const mission = result.data;
          SetMissionData(mission || {});
          setFormValues((prev) => ({
            ...prev,
            agenda_id: mission.agedref?.mission_planning_agenda_id || 0, // ID de l'agenda
          }));
  
          if (mission.agendas?.length) {
            const agendas = mission.agendas;

            let allDestinations = [];
            let allVehicles = [];
            let allDrivers = [];
              const [driversResult, vehiclesResult] = await Promise.all([  // Récupérer chauffeurs et véhicules
                VehicleService.getDriversMission(),
                VehicleService.getAllVehicles(),
              ]);

              if (driversResult?.data){ allDrivers = driversResult.data; setDrivers(driversResult.data); };
              if (vehiclesResult?.data) {allVehicles = vehiclesResult.data; setVehicles(vehiclesResult.data);};
           
            for (const agenda of agendas) {
              if (agenda?.mission_planning_agenda_id) {
                const agendaDestinations = await MissionTransportService.getagendaTransportRequest(agenda.mission_planning_agenda_id); // Récupérer les détails de l'agenda
                if (agendaDestinations?.data && agendaDestinations.data.length) {
                  setAffiche(true);
                  setListedestination(prev => [...prev, {agenda_id: agenda.mission_planning_agenda_id, destinations: agendaDestinations.data}]);
                  const transformedDestinations = agendaDestinations.data.map((item) => { // Transformer les destinations de l'agenda
                    setVoituresAvalailable(prev => [...prev, ...item.voituresAvalaible]);
                    setIsEdit(item.transports && item.transports.length > 0);
  
                    return {
                      id: item.id,
                      transports:  item.user_id.length > 0 &&
                       (item.transports && item.transports.length > 0 
                        ? item.transports.map((transport) => {
                            const vehicle = allVehicles.find((v) => v.vhc_id === transport.mission_planning_voiture_id) || null;
                            const driver = vehicle?.vhc_type == "FID" ? allDrivers.find((d) => d.user_id === vehicle?.driver_id) : vehicle?.driver_name || null;
                            const captain = mission?.missionnaries?.find(user => {
                              const captainInTransport = transport.missionnaries.find(u => u.is_captain == "1");
                              return user.user_id === captainInTransport?.user_id;
                            }) || null;
  
                            return {
                              type: vehicle?.vhc_type || "FID",
                              vehicle,
                              driver,
                              driverContact: "",
                              captain,
                              missionnaries: transport.missionnaries,
                              missionary_timesheet_mobility_id: transport.missionary_timesheet_mobility_id,
                              purpose: transport.transport_purpose,
                            };
                          })
                        : [{
                            type: "",
                            vehicle: null,
                            driver: null,
                            driverContact: "",
                            captain: null,
                            missionnaries: item.user_id,
                            purpose: null,
                          }]) ,
                    };
                  });
                  
                  allDestinations.push({
                    agenda_id: agenda.mission_planning_agenda_id,
                    reference: agenda.reference,
                    destinations: transformedDestinations,
                  });
                }
              }
            }
            setFormValues((prev) => ({
              ...prev,
              agendas: allDestinations,
            }));
          }
        } else {
          SetMissionData({});
        }
      } catch (error) {
        console.error("Error fetching mission details:", error);
      } finally {
        setOpenLoadingSimpleBackdrop(false);
      }
    }
  
    fetchMissionDetails();
    fetchDirections();
  }, [missionId]);

  useEffect(() => {
    function handleColapse() {
      const newOpenRows = {};
      listedestination.forEach((_, index) => {
        newOpenRows[index] = true;
      });
      setOpenRows(newOpenRows);
    }
    handleColapse();
  }, [listedestination]);

  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }

function handleChange(event, name, value, agendaIndex, destinationIndex, transportIndex) {
  event.preventDefault();

  if (name === "captain") { // Un chef de bord pour une voiture durant une mission
    let missionnary = missionData?.missionnaries.find(
      (user) => user.user_id === value.user_id
    );
    let vehicleId = formValues.agendas[agendaIndex].destinations[destinationIndex]?.transports[transportIndex]?.vehicle?.vhc_id;
    setCaptainConfirm({
      open: true,
      missionnary: missionnary.nom,
      vehicle: vehicleId,
      immatriculation: formValues.agendas[agendaIndex].destinations[destinationIndex]?.transports[transportIndex]?.vehicle?.vhc_imm,
    });
    setVehicleCaptains((prevCaptains) => ({
      ...prevCaptains,
      [vehicleId]: value,
    }));
  }

  if (name === "vehicle") { // Vérification si le nombre de missionnaires dépasse la capacité du véhicule
    const missionnaries = formValues.agendas[agendaIndex].destinations[destinationIndex].transports[transportIndex].missionnaries || [];
    if (value && missionnaries.length > value.vhc_place) {
      setWarning({ show: true, vehicleImm: value.vhc_imm, index : destinationIndex, tIndex: transportIndex });
    } else {
      setWarning({ show: false, vehicleImm: "", index: null, tIndex: null });
    }
  }

  if (name === "missionnaries") { // Vérification si le nombre de missionnaires dépasse la capacité du véhicule
    const vehicle = formValues.agendas[agendaIndex].destinations[destinationIndex].transports[transportIndex].vehicle;
    if (vehicle && value.length > vehicle.vhc_place) {
      setWarning({ show: true, vehicleImm: vehicle.vhc_imm, index : destinationIndex, tIndex : transportIndex });
    } else {
      setWarning({ show: false, vehicleImm: "", index: null, tIndex: null });
    }
  }
  setFormValues((prev) => {
    const updateTransport = (transport) => ({
      ...transport,
      [name]: name === "driverContact" ? formatPhoneNumber(value) : value,
      ...(name === "vehicle" && {
        type: value.vhc_type,
        driver:
          drivers.find((driver) => driver.user_id === value.driver_id) ||
          value.driver_name + " - " + value.driver_contact,
        captain: vehicleCaptains[value.vhc_id] || transport.captain,
      }),
      ...(name === "captain" && {
        missionnaries: value
          ? transport.missionnaries.some((m) => m.user_id === value.user_id)
            ? transport.missionnaries
            : [
                ...transport.missionnaries,
                missionData?.missionnaries.find((user) => user.user_id === value.user_id),
              ]
          : transport.missionnaries,
      }),
    });
  
    return {
      ...prev,
      agendas: prev.agendas.map((agenda, aIndex) =>
        aIndex === agendaIndex
          ? {
              ...agenda,
              destinations: agenda.destinations.map((destination, dIndex) =>
                dIndex === destinationIndex
                  ? {
                      ...destination,
                      transports: destination.transports.map((transport, tIndex) =>
                        tIndex === transportIndex ? updateTransport(transport) : transport
                      ),
                    }
                  : destination
              ),
            }
          : agenda
      ),
    };
  });
}

const handleSave = async (finalize = false) => {
  setOpenLoadingSimpleBackdrop(true);

  try {
      const dataToSend = prepareDataToSend(formValues);
      const result = await MissionTransportService.saveTransportMission(dataToSend);

      if (!result?.status) {
          setMessage({ open: true, color: 'red', messageInfo: 'Erreur lors de l\'enregistrement des données' });
          return; 
      }

      setMessage({ open: true, color: 'green', messageInfo: 'Les données ont été enregistrées avec succès' });

      if (finalize) {
          navigate('/Logistic/mission/transport_managment');
          return;
      }
      setConfirmationOM(true);
      
  } catch (error) {
      console.error("Erreur lors de l'enregistrement :", error);
      setMessage({ open: true, color: 'red', messageInfo: 'Une erreur inattendue est survenue' });
  } finally {
      setOpenLoadingSimpleBackdrop(false);
  }
};

  const handleSubmitAndGenerateOM = async () => {
    
    setOpenLoadingSimpleBackdrop(true);
    try {
      await MissionTransportService.confirmTransportMission(missionId);
      const finalizeResult = await MissionTransportService.sendDriverOM(missionId);

      if (!finalizeResult) {
          setMessage({ open: true, color: 'red', messageInfo: 'Erreur lors de la génération de l\'ordre de mission' });
          return;
      }

      setMessage({ open: true, color: 'green', messageInfo: 'Gestion du transport confirmée.' });
     
      navigate('/Logistic/mission/transport_managment');
     
    } catch (error) {
      console.error("Erreur lors de l'enregistrement des données :", error);
      setMessage({ open: true, color: 'red', messageInfo: 'Une erreur inattendue est survenue' });
    } finally {
      setOpenLoadingSimpleBackdrop(false);
    }
  };
    const prepareDataToSend = (formValues) => {
      const transports = [];
      formValues.agendas.forEach((agenda) => {
        agenda.destinations.forEach((destination) => {
        destination.transports.forEach((transport) => {
          transport?.missionnaries.forEach((missionnary) => {
            transports.push({
              mission_planning_transport_type: transport.type,  
              vhc_id: transport.vehicle?.vhc_id || null,      
              driver_id: transport.driver?.user_id || null, 
              missionary_timesheet_mobility_id: transport?.missionary_timesheet_mobility_id || null,
              driver_contact: transport.driverContact || null,    
              captain_id: transport.captain?.user_id || null,  
              mission_id: formValues.mission_id,               
              agenda_id: agenda.agenda_id || null, 
              mission_planning_agenda_details_id: missionnary.mission_planning_agenda_details_id, 
              purpose: transport.purpose      
            });
        }); 
        });
      });
      });
      return transports;
    };

  const handleClose = () => {
    navigate('/Logistic/mission/transport_managment');
  };

  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  };

  const handleOpenDialogDetail = () => {
    setVehicleDetailData({
      ...vehicleDetailData,
      openDialog: true
    });
  }

  const handleCloseDialogDetail = () => {
    setVehicleDetailData({ ...vehicleDetailData, openDialog: false });
  }

  const handleToggleRow = (index) => {
    setOpenRows((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  }; 
  const handleAddTransport = (agendaIndex, destinationIndex) => {
    const newTransport = {
      type: "FID",
      vehicle: null,
      driver: "",
      chefDeBord: null,
      missionnaries: [],
    };
  
    setFormValues((prev) => {
      const shouldUpdateAllDestinations = !isEdit && destinationIndex === 0;
      return {
        ...prev,
        agendas: prev.agendas.map((agenda, aIndex) =>
          aIndex === agendaIndex
            ? {
                ...agenda,
                destinations: agenda.destinations.map((destination, dIndex) =>
                  shouldUpdateAllDestinations && dIndex === destinationIndex
                    ? { 
                        ...destination,
                        transports: [...destination.transports, newTransport],
                      }
                    : destination
                ),
              }
            : agenda
        ),
      };
    });
  };
  
  const handleRemoveTransport = (agendaIndex, destinationIndex, transportIndex) => {
    setFormValues(
      (prev) => ({
        ...prev,
        agendas: prev.agendas.map((agenda, aIndex) =>
          aIndex === agendaIndex
            ? {  
          ...agenda,
        destinations: agenda.destinations.map((destination, index) =>
          index === destinationIndex
            ? {
                ...destination,
                transports: destination.transports.filter((_, i) => i !== transportIndex),
              }
            : destination
        ),
      }
      : agenda
    )
      })
  );
  };

  const handleShowRequestDialog = (agendaIndex, destinationIndex) => {  //reinitilisation formrequest

    const agenda = listedestination[agendaIndex];
    const destination = agenda.destinations[destinationIndex];
    const missionnaries = destination.user_id;
    setFormRequest({
      ...formRequest,
      show: true,
      missionnaries,
      destination: destination,
      agendaId: agenda.agenda_id,
      missionId: missionId,
    });   
  };

  const handleRequestDirection = async () => {  
    if(!formRequest.direction || !formRequest.missionnaries){
      setMessage({ open: true, color: 'red', messageInfo: 'Veuillez remplir tous les champs obligatoires' });
      return;
    }

    const dataToSend = {
      mission_planning_id: formRequest.missionId,
      direction_id : formRequest.direction,
      comment : formRequest.comment,
      mission_planning_agenda_details : formRequest.missionnaries.map((missionnary) => missionnary.mission_planning_agenda_details_id),
    }
    try{
      const result = await MissionTransportService.sendVehicleRequestDirection(dataToSend);
      if(result){
        setMessage({ open: true, color: 'green', messageInfo: 'La demande a été envoyée avec succès' });
        setFormRequest({ ...formRequest, show: false });
      }
    } catch(err){
      setMessage({ open: true, color: 'red', messageInfo: 'Erreur lors de l\'envoi de la demande' });
    }
  };

  const handleChangeRequest = (event, name, value) => {
    setFormRequest({
      ...formRequest,
      [name]: value,
    });
  };

  return (
    <React.Fragment>
      <MissionVehicleDetailAdd openDialog={vehicleDetailData.openDialog} closeDialog={handleCloseDialogDetail} missionnary={missionData?.missionnary} />
      <MainContainer {...headerDataImmo}>
        <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
        <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />      

        <AppBar position="static" color="default" className={classes.AppBar}>
          <AntTabs
            value={value}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
          >
            <AntTab disableRipple label="Gestion de transport par ligne de l'agenda" className={classes.tab}/>
          </AntTabs>
        </AppBar>
          <Spacer y={2} /> 
      <Grid container xs={12} spacing={2} justifyContent="center" display="flex" flexDirection="row"
        sx={{margin: "0.25%",}}
      >

        <Grid item xs={12} sm={6} md={4}>
        
           <Grid item xs={12} sm={6} md={6}>
           <label className={classes.labelPosition}>
                  Réference de la mission
                </label>
                <Spacer y={0.2}></Spacer>
            <TextField   
              id="outlined-basic"
              size="small"
              variant="outlined"
              value={missionData.reference}
              name="name"
              type="text"
              style={{ width: '300px' }}
              disabled
            />
                <Spacer y={1}></Spacer>
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
           <label className={classes.labelPosition}>
           Lieu de destination
                </label>
                <Spacer y={0.2}></Spacer>
            <TextField   
              id="outlined-basic"
              size="small"
              variant="outlined"
              value={missionData.lieu}
              name="name"
              type="text"
              style={{ width: '300px' }}
              disabled
            />
                <Spacer y={1}></Spacer>
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
           <label className={classes.labelPosition}>
         DAte de debut
                </label>
                <Spacer y={0.2}></Spacer>
            <TextField   
              id="outlined-basic"
              size="small"
              variant="outlined"
              value={formatDate(missionData.date_begin)}
              name="name"
              type="text"
              style={{ width: '300px' }}
              disabled
            />
                <Spacer y={1}></Spacer>
        </Grid><Grid item xs={12} sm={6} md={6}>
           <label className={classes.labelPosition}>
          Date de fin
                </label>
                <Spacer y={0.2}></Spacer>
            <TextField   
              id="outlined-basic"
              size="small"
              variant="outlined"
              value={formatDate(missionData.date_end)}
              name="name"
              type="text"
              style={{ width: '300px' }}
              disabled
            />
                <Spacer y={1}></Spacer>
        </Grid>
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
        <Grid item xs={12}  >
        <label className={classes.labelPosition}>
        Objet de la mission
                </label>
                <Spacer y={0.2}></Spacer>
            <TextField
              id="outlined-basic"
              size="small"
              variant="outlined"
              value={missionData.mission_title}
              name="code"
              type="text"
              fullWidth
              disabled
            />
                <Spacer y={1}></Spacer>
        </Grid>     
        <Grid item xs={12} >
        <label className={classes.labelPosition}>
        Moyen(s) de transport souhaité
                </label>
                <Spacer y={0.2}></Spacer>
            <TextField
              id="outlined-basic"
              size="small"
              variant="outlined"
              value={missionData.transports}
              name="code"
              type="text"
              fullWidth
              disabled
            />
                <Spacer y={1}></Spacer>
        </Grid>
        <Grid item xs={12} >
        <label className={classes.labelPosition}>
        Missionnaires
                </label>
                <Spacer y={0.2}></Spacer>
                <TextField
                    multiline
                    rows={4}
                    value={missionData?.missionnaries ? missionData.missionnaries.map((user) => `- ${user.nom}`).join("\n") : ""}
                    onChange={handleChange}
                    variant="outlined"
                    fullWidth
                    disabled
                    sx={{ width: 100 }}
                    InputProps={{
                      sx: { 
                        overflow: "auto"
                      }
                    }}
                  />
        </Grid>
       </Grid>
       </Grid>
       
            <Grid container spacing={2} padding="2">
              {
                missionData.transport === "A Déterminer" &&
                <>
                  <Grid item xs={4}>
                    <Typography variant="body1" align="left" >Moyen de déplacement </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        label="direction"
                        value={missionData.transport}
                        name="transport_type"
                        onChange={handleChange}
                      >
                        <MenuItem value="A Déterminer">À déterminer</MenuItem>
                        <MenuItem value="voiture FID">Voiture FID</MenuItem>
                        <MenuItem value="voiture location">Voiture location</MenuItem>
                        <MenuItem value="Avion">Avion</MenuItem>
                        <MenuItem value="Moto">Moto</MenuItem>
                        <MenuItem value="Bateau">Bateau</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </>
              }
             <Paper variant="outlined" className={classes.paper}>
  {affiche && (
      <Grid container sx={{ margin: 2, width: "100%" }}>      
        { formValues.agendas?.map((agenda, agendaIndex) => (
            agenda.destinations.length > 0 && (
          <Grid item xs={12} key={agendaIndex} container >
              <fieldset  style={{ borderRadius: "10px", color: '#1976d2', fontSize: "24px" }} >
                <legend>&nbsp;&nbsp;{`Agenda ${agendaIndex + 1} : ${agenda.reference}`}&nbsp; &nbsp;</legend>
           
            <Grid item xs={12}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead sx={{ backgroundColor: 'rgba(0, 0, 0, 0.8)', maxHeight: '10px !important' }}>
                  <TableRow>
                    <TableCell sx={{ width: 10 }} />
                    <TableCell sx={{ width: 150 }}>Date</TableCell>
                    <TableCell sx={{ width: 200 }}>Heure</TableCell>
                    <TableCell sx={{ width: 240 }}>Lieu</TableCell>
                    <TableCell sx={{ width: 300 }}>Transport souhaité</TableCell>
                    <TableCell sx={{ width: 150 }}>Type</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {listedestination.find((dest) => dest.agenda_id === agenda.agenda_id)?.destinations.map((destination, index) => (
                    <React.Fragment key={index}>
                      <TableRow
                        sx={{
                          backgroundColor: openRows[index] ? 'rgba(242, 242, 242, 0.8)' : 'inherit',
                          '&:hover': { backgroundColor: 'rgba(0, 123, 255, 0.1)' },
                        }}
                      >
                        <TableCell>
                        <span style={{color: '#1976d2'}}>{index + 1}.</span>
                          <IconButton size="small" onClick={() => handleToggleRow(index)}>
                            {openRows[index] ? <KeyboardArrowUp color="info" /> : <KeyboardArrowDown color="info" />}
                          </IconButton>
                        </TableCell>
                        <TableCell>
                          <label className={classes.labelPosition} style={{ color: 'grey', fontSize: '16px' }}>
                            {formatDate(destination.date_begin)} - {formatDate(destination.date_end)}
                          </label>
                        </TableCell>
                        <TableCell>
                          <label className={classes.labelPosition} style={{ color: 'grey', fontSize: '16px' }}>
                            {`${destination.heure_begin} - ${destination.heure_end}`}
                          </label>
                        </TableCell>
                        <TableCell>
                          <label className={classes.labelPosition} style={{ color: 'grey', fontSize: '16px' }}>
                            {destination.type === 'DR'
                              ? `${destination.depart} - ${destination.arriver}`
                              : destination.activite === 'mis'
                              ? destination.region
                              : destination.direction_code}
                          </label>
                        </TableCell>
                        <TableCell>
                        <label className={classes.labelPosition} style={{ color: 'grey', fontSize: '16px' }}>
                          voiture
                          </label>
                          </TableCell>
                        <TableCell>
                          {destination.type === 'DM' ? (
                            <Chip icon={<CardTravelIcon />} label="Mission" variant="outlined" color="info" />
                          ) : (
                            <Chip icon={<TimeToLeaveIcon />} label="Délai de route" variant="outlined" color="info" />
                          )}
                        </TableCell>
                      </TableRow>

                      {/* Sous-tableau des détails */}
                      <TableRow>
                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                          <Collapse in={openRows[index]} timeout="auto" unmountOnExit>
                            <Spacer y={1} />
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <label
                                  className={classes.labelPosition}
                                  style={{ color: "grey", marginTop: "5px", fontWeight: "bold" }}
                                >
                                  Détails voiture(s)
                                </label>
                                <div>
                               
                                <Tooltip title="Ajouter une ligne" arrow>
                                  <Button variant="contained" color="info" size="small" onClick={() => handleAddTransport(agendaIndex, index)}>
                                    <Add  /> Ajouter voiture
                                  </Button>
                                </Tooltip>
                                </div>
                              </div>
                              {warning.show && warning.index === index ? (
                                            <Alert severity="warning" fullWidth>
                                              Le nombre de missionnaires dépasse la capacité du véhicule {warning.vehicleImm}
                                            </Alert>
                                          ) : null}
                            <Box className={classes.box}>
                              <TableContainer
                                component={Paper}
                                style={{
                                  overflowX: 'auto',
                                  marginTop: '1%',
                                  marginBottom: '2%',
                                  boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px',
                                  borderRadius: '6px',
                                  marginLeft: "0.5%",
                                  width: "99%",
                                }}
                              >
                                <Table size="small" aria-label="sous-tableau" >
                                <TableRow>
                                      <TableCell style={{ fontWeight: "bold", minWidth: "360px" }}>Voiture</TableCell>

                                      {(missionData.transport === "Avion" || missionData.transport === "Bateau") &&
                                      destination.type === "DR" ? (
                                        <TableCell style={{ fontWeight: "bold", minWidth: "200px" }}>Type</TableCell>
                                      ) : null}

                                      <TableCell style={{ fontWeight: "bold", minWidth: "300px" }}>Chauffeur</TableCell>
                                      <TableCell style={{ fontWeight: "bold", minWidth: "360px" }}>Chef de bord</TableCell>
                                      <TableCell style={{ fontWeight: "bold", minWidth: "280px" }}>Missionnaire(s)</TableCell>

                                      <TableCell
                                        style={{
                                          position: "sticky",
                                          right: 0,
                                          background: "#fff",
                                          zIndex: 1,
                                          width: "50px",
                                        }}
                                      >
                                       
                                      </TableCell>
                                    </TableRow>

                                  <TableBody>
                                    {/* Boucle sur les transports associés à la destination */}
                                    {(agenda.destinations.find((dest) => dest.id === destination.id)?.transports || []).map(
                                      (transport, tIndex) => (
                                        <TableRow key={tIndex}>
                                        

                                          <TableCell style={{ minWidth: '360px' }}>
                                            <FormControl fullWidth variant="outlined" size="small">
                                              <Autocomplete
                                                id="tags-outlined"
                                                options={voituresAvalailable[index]}
                                                getOptionLabel={(option) =>
                                                  `${option.vhc_imm} (voiture ${option.vhc_type} - ${option.vhc_place} places disponibles)`
                                                }
                                                filterSelectedOptions
                                                onChange={(event, value) =>
                                                  handleChange(event, 'vehicle', value, agendaIndex, index, tIndex)
                                                }
                                                value={transport.vehicle}
                                                renderInput={(params) => (
                                                  <TextField {...params} label="Véhicule" variant="outlined" size="small" />
                                                )}
                                              />
                                            </FormControl>
                                          </TableCell>

                                          <TableCell style={{ minWidth: '300px' }}>
                                            <TextField
                                              fullWidth
                                              size="small"
                                              variant="outlined"
                                              value={
                                                transport.type === 'FID' ? transport?.driver?.name || '' : transport?.driver || ''
                                              }
                                              name="driver"
                                              label="Chauffeur"
                                              disabled
                                            />
                                          </TableCell>
                                          <TableCell style={{ minWidth: "360px" }}>
                                            <Autocomplete
                                              options={destination?.user_id || []}
                                              getOptionLabel={(option) => (option ? option.nom.toString() : "")}
                                              filterSelectedOptions
                                              onChange={(event, value) =>
                                                handleChange(event, "captain", value, agendaIndex, index, tIndex)
                                              }
                                              value={transport.captain}
                                              renderInput={(params) => (
                                                <TextField {...params} label="Chef de bord" variant="outlined" size="small" />
                                              )}
                                            />
                                          </TableCell>
                                          <TableCell style={{ minWidth: "280px" }}>
                                            <Autocomplete
                                              multiple
                                              options={destination?.user_id || []}
                                              getOptionLabel={(option) => (option ? option.nom.toString() : "")}
                                              filterSelectedOptions
                                              onChange={(event, newValue) =>
                                                handleChange(event, "missionnaries", newValue, agendaIndex, index, tIndex)
                                              }
                                              value={transport.missionnaries}
                                              renderInput={(params) => (
                                                <TextField {...params} label="Missionnaire" variant="outlined" size="small" />
                                              )}
                                            />
                                          </TableCell>

                                          <TableCell
                                            style={{
                                              position: "sticky",
                                              right: 0,
                                              background: "#fff",
                                              zIndex: 1,
                                              width: "50px",
                                            }}
                                          >
                                            <Tooltip title="Supprimer la ligne" arrow>
                                              <IconButton size="small" onClick={() => handleRemoveTransport(agendaIndex, index, tIndex)}>
                                                <Delete color="error" />
                                              </IconButton>
                                            </Tooltip>
                                          </TableCell>
                                         
                                        </TableRow>
                                      )
                                    )}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </Grid>
            </fieldset>
          </Grid>
       ) ))}
        
      </Grid>
    
  )}          
              <Box container item xs={12} spacing={2} display="flex" justifyContent="flex-end" sx={{marginTop: "20px", marginBottom: "20px"}}>
                <Button
                  variant="contained"
                  color="error"
                  size="medium"
                  style={{  marginRight: '30px', }}
                  onClick={handleClose}
                  autoFocus
                >
                  Annuler
                </Button>
                <Button
                  variant="contained"
                  color="info"
                  size="medium"
                  style={{ marginRight: '30px', }}
                  onClick={() => handleSave(true)}
                  autoFocus
                >
                  Enregistrer
                </Button>
                {/* <Button
                  variant="contained"
                 color="info"
                  size="medium"
                  style={{ marginRight: '30px',}}
                  onClick={() => handleSave(false)}
                  autoFocus
                >
                  Enregistrer et Clôturer
                </Button> */}
              </Box>
              </Paper>
            </Grid>
         
            <Dialog
        open={confirmationOM}
        onClose={() => setConfirmationOM(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {
             "La gestion du transport sera finalisée. L'Ordre de Mission (OM) du chauffeur sera envoyé au chauffeur."
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained"  component="span" onClick={() => {
            setConfirmationOM(false)
            navigate('/Logistic/mission/transport_managment');
            }}>
            Anuller
          </Button>
          <Button variant="contained" color="primary" component="span" onClick={() => handleSubmitAndGenerateOM()}>
            Confirmer
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={captainConfirm.open}
        onClose={() => setCaptainConfirm({
          open: false,
          missionnary: '',
          vehicle: ''
        })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {
              `${captainConfirm.missionnary} sera le chef de bord de la voiture ${captainConfirm.immatriculation} durant la mission.`
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" component="span" onClick={() => {
            setCaptainConfirm({
              open: false,
              missionnary: '',
              vehicle: ''
            });
          }}>
            Fermer
          </Button>
        </DialogActions>
      </Dialog>
    </MainContainer>

    </React.Fragment>
  );
}

